import { put, call } from 'redux-saga/effects'
import { getTalentAdvisor } from '../apiModules/talentAdvisors'
import { talentAdvisorEntities } from '../reducks'

export function* fetchTalentAdvisorEntitySaga(candidateProfileId) {
  const response = yield call(getTalentAdvisor, candidateProfileId)
  yield put(talentAdvisorEntities.addItem(response.result.id, response.result))
  return response
}
